/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Cmp_Hero_TitleInputs */

const en_cmp_hero_title = /** @type {(inputs: Cmp_Hero_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bystep vs ${i?.name}`)
};

const id_cmp_hero_title = /** @type {(inputs: Cmp_Hero_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bystep vs ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Bystep vs {name}" |
*
* @param {Cmp_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_hero_title = /** @type {((inputs: Cmp_Hero_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Hero_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_hero_title(inputs)
	return en_cmp_hero_title(inputs)
});